/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get("search-form")) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer =
        this.closest("#Search-Drawer") || this.closest("#Facet-Drawer");

      if (!this.is_drawer && this.closest("#Facet-Drawer")) {
        this.is_drawer = "1";
      }

      this.form = this.querySelector("form");
      this.button = document.querySelectorAll(".thb-quick-search");
      this.input = this.querySelector(".search-field");
      this.defaultTab = this.querySelector(".side-panel-content--initial");

      if (this.is_drawer) {
        const hasTabsContainer = this.querySelector(
          ".side-panel-content--has-tabs .thb-predictive-search"
        );
        const initialContainer = this.querySelector(
          ".side-panel-content--initial .thb-predictive-search"
        );
        const directContainer = this.querySelector(".thb-predictive-search");
        this.predictiveSearchResults =
          hasTabsContainer || initialContainer || directContainer;
      } else {
        this.predictiveSearchResults = this.querySelector(
          ".thb-predictive-search"
        );
      }

      this.cc = this.querySelector(".searchform--click-capture");

      this.setupEventListeners();
    }

    disconnectedCallback() {
      if (this.boundHeaderClickOutside) {
        document.removeEventListener("mousedown", this.boundHeaderClickOutside);
      }
      if (this.boundFilterClickOutside) {
        document.removeEventListener("click", this.boundFilterClickOutside);
      }
    }

    setupEventListeners() {
      this.form.addEventListener("submit", this.onFormSubmit.bind(this));

      if (this.input.id === "header-search-input") {
        this.setupHeaderSearchListeners();
      } else {
        this.setupFilterSearchListeners();
      }

      if (!this.closest("#Facet-Drawer")) {
        this.button.forEach((item, i) => {
          item.addEventListener("click", (event) => {
            event.preventDefault();
            document.body.classList.add("open-cc");
            if (this.is_drawer && this.drawer) {
              this.drawer.classList.add("active");
              if (this.drawer.id === "Search-Drawer") {
                if (this.defaultTab) {
                  this.defaultTab.style.display = "";
                }
                const hasTabsContainer = this.querySelector(
                  ".side-panel-content--has-tabs"
                );
                if (hasTabsContainer) {
                  hasTabsContainer.style.display = "none";
                }
              }
            }
            return false;
          });
        });
      }

      document.addEventListener("keyup", (e) => {
        if (e.code && e.code.toUpperCase() === "ESCAPE") {
          this.close();
        }
      });
    }

    setupHeaderSearchListeners() {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onHeaderChange(event);
        }, 300).bind(this)
      );

      this.input.addEventListener(
        "focus",
        debounce((event) => {
          this.onHeaderChange(event);
        }, 300).bind(this)
      );

      this.headerClickOutside = (event) => {
        if (!this.predictiveSearchResults.classList.contains("active")) {
          return;
        }

        if (
          !this.contains(event.target) &&
          !this.predictiveSearchResults.contains(event.target)
        ) {
          this.close();
        }
      };

      this.boundHeaderClickOutside = this.headerClickOutside.bind(this);
      document.addEventListener("mousedown", this.boundHeaderClickOutside);
    }

    setupFilterSearchListeners() {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.addEventListener(
        "focus",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.addEventListener(
        "keyup",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.addEventListener("focusout", (event) => {
        setTimeout(() => {
          if (
            !this.predictiveSearchResults.contains(document.activeElement) &&
            !this.contains(document.activeElement) &&
            this.predictiveSearchResults.classList.contains("active")
          ) {
            this.close();
          }
        }, 150);
      });

      this.input.addEventListener("change", (event) => {
        this.onChange(event);
      });

      this.input.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          const searchTerm = this.getQuery();
          if (
            !searchTerm.length &&
            this.input.id !== "search-input" &&
            this.input.id !== "mobile-search-input"
          ) {
            event.preventDefault();
            return false;
          }
        }
      });

      this.cc?.addEventListener("click", this.close.bind(this));

      this.filterClickOutside = (event) => {
        if (!this.predictiveSearchResults.classList.contains("active")) {
          return;
        }

        if (
          !this.contains(event.target) &&
          !this.predictiveSearchResults.contains(event.target)
        ) {
          this.close();
        }
      };

      this.boundFilterClickOutside = this.filterClickOutside.bind(this);
      document.addEventListener("click", this.boundFilterClickOutside);
    }

    getQuery() {
      return this.input.value.trim();
    }

    onHeaderChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.open();
      this.predictiveSearchResults.classList.add("active");
      this.getSearchResults(searchTerm);
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        if (!this.is_drawer) {
          this.close();
        } else {
          if (this.predictiveSearchResults) {
            this.predictiveSearchResults.innerHTML = "";
            this.predictiveSearchResults.classList.remove("active");
            this.predictiveSearchResults.style.display = "none";
          }

          if (
            this.defaultTab &&
            this.drawer &&
            this.drawer.id === "Search-Drawer"
          ) {
            this.defaultTab.style.display = "";
          }
          const hasTabsContainer = this.querySelector(
            ".side-panel-content--has-tabs"
          );
          if (
            hasTabsContainer &&
            this.drawer &&
            this.drawer.id === "Search-Drawer"
          ) {
            hasTabsContainer.style.display = "none";
            hasTabsContainer.classList.remove("active");
          }
        }
        return;
      }

      if (!this.is_drawer) {
        this.open();
      } else {
        if (
          this.defaultTab &&
          this.drawer &&
          this.drawer.id === "Search-Drawer"
        ) {
          this.defaultTab.style.display = "none";
        }
        const hasTabsContainer = this.querySelector(
          ".side-panel-content--has-tabs"
        );
        if (
          hasTabsContainer &&
          this.drawer &&
          this.drawer.id === "Search-Drawer"
        ) {
          hasTabsContainer.style.display = "";
          hasTabsContainer.classList.add("active");
        }

        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.style.display = "";
        }
      }

      this.predictiveSearchResults.classList.add("active");
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (
        !this.getQuery().length &&
        this.input.id !== "search-input" &&
        this.input.id !== "mobile-search-input"
      ) {
        event.preventDefault();
        return false;
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.predictiveSearchResults.innerHTML = "";
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      this.predictiveSearchResults.classList.add("loading");

      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&${encodeURIComponent(
          "resources[type]"
        )}=product,article,query,page&${encodeURIComponent(
          "resources[limit]"
        )}=10&section_id=predictive-search`
      )
        .then((response) => {
          this.predictiveSearchResults.classList.remove("loading");
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          this.predictiveSearchResults.classList.remove("loading");
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.predictiveSearchResults.removeAttribute("inert");
      this.predictiveSearchResults.style.pointerEvents = "auto";
      this.predictiveSearchResults.style.zIndex = "1000";

      setTimeout(() => {
        this.setupTabs();
      }, 10);

      setTimeout(() => {
        this.setupProductClickHandlers();
      }, 10);

      const searchResultsSubmit = this.predictiveSearchResults.querySelector(
        "#search-results-submit"
      );
      if (searchResultsSubmit) {
        if (!this.is_drawer) {
          searchResultsSubmit.classList.remove("button");
        }
        searchResultsSubmit.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.form.submit();
          },
          { passive: false }
        );

        searchResultsSubmit.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.form.submit();
          },
          { passive: false }
        );

        searchResultsSubmit.style.pointerEvents = "auto";
        searchResultsSubmit.style.zIndex = "1001";
      }
    }

    setupTabs() {
      const tabs = this.predictiveSearchResults.querySelectorAll(
        ".side-panel-content--tabs button"
      );
      const panels = this.predictiveSearchResults.querySelectorAll(
        ".side-panel-content--tab-panel"
      );

      tabs.forEach((tab, index) => {
        tab.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopPropagation();

            tabs.forEach((t) => t.classList.remove("tab-active"));
            panels.forEach((p) => p.classList.remove("tab-active"));

            tab.classList.add("tab-active");
            if (panels[index]) {
              panels[index].classList.add("tab-active");
            }
          },
          { passive: false }
        );

        tab.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();

            tabs.forEach((t) => t.classList.remove("tab-active"));
            panels.forEach((p) => p.classList.remove("tab-active"));

            tab.classList.add("tab-active");
            if (panels[index]) {
              panels[index].classList.add("tab-active");
            }
          },
          { passive: false }
        );

        tab.style.pointerEvents = "auto";
        tab.style.zIndex = "1001";
      });
    }

    setupProductClickHandlers() {
      const productCards = this.predictiveSearchResults.querySelectorAll(
        ".product-card-small"
      );
      productCards.forEach((card, index) => {
        const clickHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();

          const productUrl = card.dataset.url || card.querySelector("a")?.href;
          if (productUrl) {
            window.location.href = productUrl;
          }
        };

        card.addEventListener("click", clickHandler, { passive: false });
        card.addEventListener("touchend", clickHandler, { passive: false });

        card.style.cursor = "pointer";
        card.style.pointerEvents = "auto";
        card.style.zIndex = "1001";
        card.style.position = "relative";

        card.addEventListener(
          "touchstart",
          () => {
            card.style.backgroundColor = "rgba(164, 42, 226, 0.1)";
          },
          { passive: true }
        );

        card.addEventListener(
          "touchend",
          () => {
            setTimeout(() => {
              card.style.backgroundColor = "";
            }, 150);
          },
          { passive: true }
        );
      });

      const productLinks = this.predictiveSearchResults.querySelectorAll(
        ".product-card-small--link, .product-cart-item-image-link, .cart-product-link"
      );
      productLinks.forEach((link) => {
        link.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = link.href;
          },
          { passive: false }
        );

        link.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = link.href;
          },
          { passive: false }
        );
      });

      const suggestionLinks = this.predictiveSearchResults.querySelectorAll(
        ".predictive-search__item, .thb-predictive-search--popular a"
      );
      suggestionLinks.forEach((link) => {
        link.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = link.href;
          },
          { passive: false }
        );

        link.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = link.href;
          },
          { passive: false }
        );
      });
    }

    close() {
      if (!this.predictiveSearchResults.classList.contains("active")) {
        return;
      }

      this.predictiveSearchResults.setAttribute("inert", "");
      this.predictiveSearchResults.classList.remove("active");
      document.body.classList.remove("open-search");

      if (this.is_drawer && this.drawer && this.drawer.id === "Search-Drawer") {
        if (this.defaultTab) {
          this.defaultTab.style.display = "";
        }
        const hasTabsContainer = this.querySelector(
          ".side-panel-content--has-tabs"
        );
        if (hasTabsContainer) {
          hasTabsContainer.style.display = "none";
          hasTabsContainer.classList.remove("active");
        }
      }
    }

    open() {
      document.body.classList.add("open-search");
      this.predictiveSearchResults.removeAttribute("inert");
    }
  }
  customElements.define("search-form", SearchForm);
}
